/**
 * Telling a composed snippet from a pasted HTML document.
 *
 * The composer produces fragments — paragraphs, lists, links. An admin who
 * pastes a designed mailer through the source-code window hands over something
 * else entirely: a whole document, with its own <head>, its own <style>, and a
 * table layout that a contentEditable would quietly rewrite and a page-level
 * stylesheet would leak out of.
 *
 * So the two are handled differently everywhere they are shown or sent, and
 * this single predicate is what decides which is which. The API applies the
 * same rule (MailCampaign::bodyIsFullDocument) — keep the two in step.
 */
export function isFullHtmlDocument(html?: string | null): boolean {
  if (!html) return false;
  return /<\s*(!doctype\s+html|html|head|body|style)\b/i.test(html);
}
